import { WLField } from "../components/dumb/WLFieldsEditor";

/** IS-188 */
export const DEFAULT_WORD_LIMIT = 100;
export const DEFAULT_WORD_LIMIT_OPTIONS = [
  { value: "100", label: "100" },
  { value: "200", label: "200" },
  { value: "300", label: "300" },
  { value: "400", label: "400" },
  { value: "500", label: "500" },
];
const parseWordLimit = (() => {
  const arr = DEFAULT_WORD_LIMIT_OPTIONS.map(i => parseInt(i.value, 10));

  return (input: string|number) => {
    input = parseInt(input as string, 10);
    return arr.indexOf(input) > -1 ? input : DEFAULT_WORD_LIMIT;
  };
})();

export default class AriaHelper {

  static getSectionKey(section: WLField) {
    return typeof section?.name === "string"
      ? section.name.trim().replace(/\s+/g, '')
      : "";
  }

  static parseWordLimit = parseWordLimit;

  static checkWordLimitOnFields = (fields: any[]) => {
    if (!Array.isArray(fields)) {
      return [];
    }

    return fields.map(item => {
      item.max_word = parseWordLimit(item.max_word);
      return item;
    });
  };

  static getSectionsWordLimit(sections: Array<WLField> = []) {
    if (Array.isArray(sections) && sections.length > 0) {
      return sections.reduce((ret, curr) => {
        const wordLimit = parseWordLimit(parseInt(curr.max_word as string, 10));

        if (wordLimit > 0) {
          ret[this.getSectionKey(curr)] = wordLimit;
        }

        return ret;
      }, {} as TPlainObject);
    } else {
      return {};
    }
  }

}
